import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CollectionPaths } from '@models/collections';
import { Encumbrance } from '@models/encumbrance';
import { Store } from '@ngxs/store';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { NavigationService } from '@services/nav/nav.service';
import { UserProfileState } from '@state/user-profile';
import { filter, map, switchMap, tap } from 'rxjs/operators';

export const EncumbranceExists: CanActivateFn = (activatedRouteSnapshot) => {
	const encumbranceId = activatedRouteSnapshot.paramMap.get('encumbranceId');
	const matterId = activatedRouteSnapshot.paramMap.get('matterId');
	const navService = inject(NavigationService);
	const store = inject(Store);
	const firestore = new FirestoreRepo<Encumbrance, { businessId: string }>(
		({ businessId }) =>
			CollectionPaths.business_matter_encumbrances(businessId, matterId),
	);

	if (!encumbranceId) {
		if (matterId) {
			navService.goToMatter_Mortgages_Encumbrances(matterId);
		} else {
			navService.goToDashboard();
		}
		return false;
	}
	return store.select(UserProfileState.getCurrentBusinessId).pipe(
		filter((businessId) => !!businessId),
		switchMap((businessId) => firestore.Get(encumbranceId, { businessId })),
		map((doc) => doc.exists()),
		tap((exists) => {
			if (!exists) {
				if (matterId) {
					navService.goToMatter_Mortgages_Encumbrances(matterId);
				} else {
					navService.goToDashboard();
				}
			}
		}),
	);
};
